import Vue from 'vue'
import VueRouter from 'vue-router'
// import {
//   Dialog,
// } from 'vant'

// Vue.use(Dialog)
// import Home from '../views/Home.vue'
const Home = () => import('../views/Home.vue'); //主页
const Class = () => import('../views/Class.vue'); //分类
const Manufactures = () => import('../views/Manufactures.vue'); //厂家直购
const Car = () => import('../views/Car.vue'); //购物车
const My = () => import('../views/My.vue'); //我的
const Yz = () => import('../components/city/yan.vue'); //特殊店铺验证密码
const City = () => import('../components/city/city.vue'); //城市
const Start = () => import('../components/home/child/start.vue'); //启动图
const Login = () => import('../components/login/login.vue'); //登录
const Logon = () => import('../components/login/child/logon.vue'); //注册
const Retrieve = () => import('../components/login/child/retrieve.vue'); //找回密码
const Agreement = () => import('../components/login/child/agreement.vue'); //找回密码
const Agreement1 = () => import('../components/login/child/agreement1.vue'); //找回密码
const Agreement2 = () => import('../components/login/child/vxie.vue'); //xie
const Agreement3 = () => import('../components/my/vip/vxie.vue'); //xie
const Product = () => import('../components/product/product.vue'); //产品
const Tianp = () => import('../components/product/tianp.vue'); //天天产品
const Products = () => import('../components/product/products.vue'); //产品s
const Products11 = () => import('../components/product/ps11.vue'); //产品s11
const Brandproduct = () => import('../components/product/brandproduct.vue'); //二级品牌产品
const Brandproducts = () => import('../components/product/brand.vue'); //二级品牌产品s
const Brandproducts11 = () => import('../components/product/bs11.vue'); //二级品牌产品s11
const Lp = () => import('../components/product/longp.vue'); //二级品牌产品s11
const Lp1 = () => import('../components/product/longp1.vue'); //二级品牌产品s11
const ProductList = () => import('../components/product/productList.vue'); //产品列表
const PinProduct = () => import('../components/product/pinproduct.vue'); //品牌产品列表
const Activity = () => import('../components/activity/activity.vue'); //活动
const Search = () => import('../components/search/search'); //搜索
const Order = () => import('../components/order/Order'); //订单
const Ordertest = () => import('../components/order/ordertest'); //订单
const OrderList = () => import('../components/order/orderList'); //订单列表
const OrderDetails = () => import('../components/order/details'); //订单详情
const OrderT = () => import('../components/order/tui'); //退货
const OrderT1 = () => import('../components/order/tui1'); //退货
const OrderT2 = () => import('../components/order/tui2'); //退货
const OrderT3 = () => import('../components/order/tui3'); //退货
const OrderC = () => import('../components/order/xiude'); //修改订单详情
const Address = () => import('../components/address/address'); //收货地址
const ReviseAddress = () => import('../components/address/reviseads'); //修改收货地址
const Modify = () => import('../components/address/modify'); //修改收货地址
const OptAddress = () => import('../components/address/optads'); //选择收货地址
const Tax = () => import('../components/address/tax'); //发票信息
const OptAddress2 = () => import('../components/address/optads2'); //选择收货地址
const Bao = () => import('../components/address/bao'); //选择收货地址
const Cashier = () => import('../components/cashier/cashier'); //收银台
const Transfer = () => import('../components/cashier/transfer'); //银行转账
const Over = () => import('../components/cashier/over'); //支付完成
const Collect = () => import('../components/collect/collect.vue'); //收藏列表
const Sets = () => import('../components/my/set.vue'); //设置
const Logoff = () => import('../components/my/logoff.vue'); //设置
const Means = () => import('../components/my/means.vue'); //个人信息
const Revise = () => import('../components/my/revise.vue'); //修改密码
const Coupon = () => import('../components/my/coupon.vue'); //优惠劵
const Vip = () => import('../components/my/vip/openvip.vue'); //超级会员
const Xie = () => import('../components/my/vip/xie.vue'); //超级会员协议
const Customer = () => import('../components/my/customer.vue'); //客服
const Notice = () => import('../components/notice/notice.vue'); //公告
const Notices = () => import('../components/notice/notices.vue'); //公告内
const Hierarchy = () => import('../components/my/hierarchyRule.vue'); //会员权益
const Ren = () => import('../components/my/ren.vue'); //认证
const Renx = () => import('../components/my/renx.vue'); //认证
const Shen = () => import('../components/my/shen.vue'); //认证
const Sks = () => import('../components/pin/sks'); //三棵树
const Sks1 = () => import('../components/pin/sks1'); //三棵树1
const Tbb = () => import('../components/pin/tbb'); //兔宝宝
const Tzbb = () => import('../components/pin/ztbb'); //兔宝宝
const Lfj = () => import('../components/pin/lfj'); //拉法基
const Ts = () => import('../components/pin/ts'); //拉法基
const Ca = () => import('../components/pin/ca.vue'); //拉法基
const Xs = () => import('../components/pin/xs.vue'); //拉法基
const Fsl = () => import('../components/pin/fsl'); //法狮龙
const Yy = () => import('../components/pin/yy'); //悠扬
const Yuns = () => import('../components/pin/yuns'); //悠扬
const Spell = () => import('../components/activity/spell.vue'); //拼团
const Jian = () => import('../components/activity/jian.vue'); //捡漏
const Fan = () => import('../components/activity/fan.vue'); //返利
const Fanx = () => import('../components/activity/fanx.vue'); //返利
const Fanxy = () => import('../components/activity/fanxy.vue'); //返利
const Fanxxy = () => import('../components/activity/fanxxy.vue'); //返利
const Shang = () => import('../components/activity/shang.vue'); //商信通
const Tui = () => import('../components/activity/bai.vue'); //商信通
const Tui1 = () => import('../components/activity/bai1.vue'); //商信通
const Tui2 = () => import('../components/activity/bai2.vue'); //商信通
const Tui3 = () => import('../components/activity/bai3.vue'); //商信通
const Zheng = () => import('../components/activity/zheng.vue'); //s11
const Zhengp = () => import('../components/product/bszheng.vue'); //s11

const Ss = () => import('../components/activity/ss11.vue'); //s11
const Dao = () => import('../components/activity/dao.vue'); //s11
const Yan = () => import('../components/activity/yan.vue'); //s11
const Tian = () => import('../components/activity/tian.vue'); //天天特价
const Gong = () => import('../components/activity/gong.vue'); //工厂
const Gongx = () => import('../components/activity/gongx.vue'); //工厂
const Gongd = () => import('../components/activity/gongd.vue'); //工厂
const Gongl = () => import('../components/activity/gongl.vue'); //工厂
const Gongs = () => import('../components/activity/gongs.vue'); //工厂
const Dian = () => import('../components/activity/dian.vue'); //好店
const Tao = () => import('../components/activity/tao/tao.vue'); //套
const Tao1 = () => import('../components/activity/tao/tao1.vue'); //套
const Tao2 = () => import('../components/activity/tao/tao2.vue'); //套
const Tao3 = () => import('../components/activity/tao/tao3.vue'); //套
const Taop = () => import('../components/activity/tao/taop.vue'); //套
const Taoh = () => import('../components/activity/tao/index.vue'); //套
const Taoh1 = () => import('../components/activity/tao/ti1.vue'); //套
const Taoh2 = () => import('../components/activity/tao/ti2.vue'); //套
const Taoh3 = () => import('../components/activity/tao/ti3.vue'); //套
const Taoh4 = () => import('../components/activity/tao/ti4.vue'); //套
const Taoh5 = () => import('../components/activity/tao/ti5.vue'); //套
const Taohh = () => import('../components/activity/tao/tih.vue'); //套
const Taohn = () => import('../components/activity/tao/taoh.vue'); //套
const Taohnf = () => import('../components/activity/tao/taohnf.vue'); //套
const Taohnpf = () => import('../components/activity/tao/taohnpf.vue'); //套
const Taohp = () => import('../components/activity/tao/taohp.vue'); //套
const Taoc = () => import('../components/activity/tao/taoc.vue'); //套
const Bing = () => import('../components/activity/bing/bing.vue'); //套
const Bingx = () => import('../components/activity/bing/bingx.vue'); //套
const Bingp = () => import('../components/activity/bing/bingp.vue'); //套
const Shop = () => import('../components/shop/shop.vue'); //店铺
const Shopc = () => import('../components/shop/child/Class.vue'); //店铺分类
const Svipm = () => import('../components/my/opvip.vue'); //店铺分类
const Svip2 = () => import('../components/my/op2.vue'); //店铺分类
// const Fan = () => import('../components/collect/fan.vue'); //返利
//促销
const Chux = () => import('../components/activity/pin/index.vue');
const Chuxp = () => import('../components/product/chupro.vue');
const Chuxo = () => import('../components/order/chuorder.vue');
const Chuxs = () => import('../components/cashier/chus.vue');
const Chuxol = () => import('../components/order/corderList.vue');
const Chuxt = () => import('../components/cashier/chut.vue');
const Jvip = () => import('../components/activity/pin/vip.vue');


Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/class',
    name: 'class',
    component: Class
  },
  {
    path: '/manufactures',
    name: 'manufactures',
    component: Manufactures
  },
  {
    path: '/car',
    name: 'car',
    component: Car
  },
  {
    path: '/my',
    name: 'my',
    component: My
  },
  {
    path: '/city',
    name: 'city',
    component: City
  },
  {
    path: '/yz',
    name: 'yz',
    component: Yz
  },
  {
    path: '/start',
    name: 'start',
    component: Start
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/logon',
    name: 'logon',
    component: Logon
  },
  {
    path: '/retrieve',
    name: 'retrieve',
    component: Retrieve
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: Agreement
  },
  {
    path: '/agreement1',
    name: 'agreement1',
    component: Agreement1
  },
  {
    path: '/agreement2',
    name: 'agreement2',
    component: Agreement2
  },
  {
    path: '/agreement3',
    name: 'agreement3',
    component: Agreement3
  },
  {
    path: '/product',
    name: 'product',
    component: Product,
  },
  {
    path: '/products',
    name: 'products',
    component: Products,
  },
  {
    path: '/products11',
    name: 'products11',
    component: Products11,
  },
  {

    path: '/brandproduct',
    name: 'brandproduct',
    component: Brandproduct,
  },
  {
    path: '/brandproducts',
    name: 'brandproducts',
    component: Brandproducts,
  },
  {
    path: '/brandproducts11',
    name: 'brandproducts11',
    component: Brandproducts11,
  },
  {
    path: '/lp',
    name: 'lp',
    component: Lp,
  },
  {
    path: '/lp1',
    name: 'lp1',
    component: Lp1,
  },
  {
    path: '/productList',
    name: 'productList',
    component: ProductList,
  },
  {
    path: '/pinproduct',
    name: 'pinproduct',
    component: PinProduct,
  },
  {
    path: '/activity',
    name: 'activity',
    component: Activity,
  },
  {
    path: '/search',
    name: 'search',
    component: Search,
  },
  {
    path: '/order',
    name: 'order',
    component: Order,
  },
  {
    path: '/ordertest',
    name: 'ordertest',
    component: Ordertest,
  },
  {
    path: '/orderList',
    name: 'orderList',
    component: OrderList,
  },

  {
    path: '/details',
    name: 'details',
    component: OrderDetails,
  },
  {
    path: '/tui',
    name: 'tui',
    component: OrderT,
  },
  {
    path: '/tui1',
    name: 'tui1',
    component: OrderT1,
  }, {
    path: '/tui2',
    name: 'tui2',
    component: OrderT2,
  },
  {
    path: '/tui3',
    name: 'tui3',
    component: OrderT3,
  },
  {
    path: '/xiu',
    name: 'xiu',
    component: OrderC,
  },
  {
    path: '/address',
    name: 'address',
    component: Address,
  },
  {
    path: '/reviseads',
    name: 'reviseads',
    component: ReviseAddress,
  },
  {
    path: '/modify',
    name: 'modify',
    component: Modify,
  },
  {
    path: '/optads',
    name: 'optads',
    component: OptAddress,
  },
  {
    path: '/tax',
    name: 'tax',
    component: Tax,
  },
  {
    path: '/optads2',
    name: 'optads2',
    component: OptAddress2,
  },
  {
    path: '/bao',
    name: 'bao',
    component: Bao,
  },
  {
    path: '/cashier',
    name: 'cashier',
    component: Cashier,
  },
  {
    path: '/transfer',
    name: 'transfer',
    component: Transfer,
  },
  {
    path: '/over',
    name: 'over',
    component: Over,
  },
  {
    path: '/collect',
    name: 'collect',
    component: Collect,
  },
  {
    path: '/set',
    name: 'set',
    component: Sets,
  },
  {
    path: '/logoff',
    name: 'logoff',
    component: Logoff,
  },
  {
    path: '/means',
    name: 'means',
    component: Means,
  },
  {
    path: '/revise',
    name: 'revise',
    component: Revise,
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: Coupon,
  },
  {
    path: '/vip',
    name: 'vip',
    component: Vip,
  },
  {
    path: '/xie',
    name: 'xie',
    component: Xie,
  },
  {
    path: '/customer',
    name: 'customer',
    component: Customer,
  },
  {
    path: '/notice',
    name: 'notice',
    component: Notice,
  },
  {
    path: '/notices',
    name: 'notices',
    component: Notices,
  },
  {
    path: '/hierarchy',
    name: 'hierarchy',
    component: Hierarchy,
  },
  {
    path: '/ren',
    name: 'ren',
    component: Ren,
  },
  {
    path: '/renx',
    name: 'renx',
    component: Renx,
  },
  {
    path: '/sks',
    name: 'sks',
    component: Sks,
  },
  {
    path: '/sks1',
    name: 'sks1',
    component: Sks1,
  },
  {
    path: '/tbb',
    name: 'tbb',
    component: Tbb,
  },
  {
    path: '/ztbb',
    name: 'ztbb',
    component: Tzbb,
  },
  {
    path: '/lfj',
    name: 'lfj',
    component: Lfj,
  },
  {
    path: '/ts',
    name: 'ts',
    component: Ts,
  },
  {
    path: '/xs',
    name: 'xs',
    component: Xs,
  },
  {
    path: '/ca',
    name: 'ca',
    component: Ca,
  },
  {
    path: '/fsl',
    name: 'fsl',
    component: Fsl,
  },
  {
    path: '/yy',
    name: 'yy',
    component: Yy,
  },
  {
    path: '/yuns',
    name: 'yuns',
    component: Yuns,
  },
  {
    path: '/spell',
    name: 'spell',
    component: Spell,
  },
  {
    path: '/jian',
    name: 'jian',
    component: Jian,
  },
  {
    path: '/fan',
    name: 'fan',
    component: Fan,
  },
  {
    path: '/fanx',
    name: 'faxn',
    component: Fanx,
  },
  {
    path: '/fanxy',
    name: 'fanxy',
    component: Fanxy,
  },
  {
    path: '/fanxxy',
    name: 'faxnxy',
    component: Fanxxy,
  },
  {
    path: '/shang',
    name: 'shang',
    component: Shang,
  },
  {
    path: '/bai',
    name: 'bai',
    component: Tui,
  }, {
    path: '/bai2',
    name: 'bai2',
    component: Tui2,
  }, {
    path: '/bai3',
    name: 'bai3',
    component: Tui3,
  }, {
    path: '/bai1',
    name: 'bai1',
    component: Tui1,
  },
  {
    path: '/zheng',
    name: 'zheng',
    component: Zheng,
  },
  {
    path: '/zhengp',
    name: 'zhengp',
    component: Zhengp,
  },
  {
    path: '/ss',
    name: 'ss',
    component: Ss,
  },
  {
    path: '/tao',
    name: 'tao',
    component: Tao,
  },
  {
    path: '/tao1',
    name: 'tao1',
    component: Tao1,
  },

  {
    path: '/tao2',
    name: 'tao2',
    component: Tao2,
  },
  {
    path: '/tao3',
    name: 'tao3',
    component: Tao3,
  },
  {
    path: '/taop',
    name: 'taop',
    component: Taop,
  },
  {
    path: '/taoh',
    name: 'taoh',
    component: Taoh,
  },
  {
    path: '/taoh1',
    name: 'taoh1',
    component: Taoh1,
  }, {
    path: '/taoh2',
    name: 'taoh2',
    component: Taoh2,
  }, {
    path: '/taoh3',
    name: 'taoh3',
    component: Taoh3,
  }, {
    path: '/taoh4',
    name: 'taoh4',
    component: Taoh4,
  }, {
    path: '/taoh5',
    name: 'taoh5',
    component: Taoh5,
  },
  {
    path: '/taohh',
    name: 'taohh',
    component: Taohh,
  },
  {
    path: '/dao',
    name: 'dao',
    component: Dao,
  },
  {
    path: '/taohn',
    name: 'taohn',
    component: Taohn,
  },
  {
    path: '/taohnf',
    name: 'taohnf',
    component: Taohnf,
  },
  {
    path: '/taohnpf',
    name: 'taohnpf',
    component: Taohnpf,
  },
  {
    path: '/taohp',
    name: 'taohp',
    component: Taohp,
  },
  {
    path: '/bing',
    name: 'bing',
    component: Bing,
  },
  {
    path: '/bingx',
    name: 'bingx',
    component: Bingx,
  },
  {
    path: '/bingp',
    name: 'bingp',
    component: Bingp,
  },
  {
    path: '/taoc',
    name: 'taoc',
    component: Taoc,
  },
  {
    path: '/yan',
    name: 'yan',
    component: Yan,
  },
  {
    path: '/shop',
    name: 'shop',
    component: Shop,
  },
  {
    path: '/shopc',
    name: 'shopc',
    component: Shopc,
  },
  {
    path: '/opvip',
    name: 'opvip',
    component: Svipm,
  },
  {
    path: '/opvip2',
    name: 'opvip2',
    component: Svip2,
  },
  {
    path: '/tian',
    name: 'tian',
    component: Tian,
  },
  {
    path: '/tianp',
    name: 'tianp',
    component: Tianp,
  },
  {
    path: '/gong',
    name: 'gong',
    component: Gong,
  },
  {
    path: '/gongx',
    name: 'gongx',
    component: Gongx,
  },
  {
    path: '/gongl',
    name: 'gongl',
    component: Gongl,
  },
  {
    path: '/gongs',
    name: 'gongs',
    component: Gongs,
  },
  {
    path: '/gongd',
    name: 'gongd',
    component: Gongd,
  },
  {
    path: '/dian',
    name: 'dian',
    component: Dian,
  },
  {
    path: '/chux',
    name: 'chux',
    component: Chux,
  },
  {
    path: '/chuxp',
    name: 'chuxp',
    component: Chuxp,
  },
  {
    path: '/chuxo',
    name: 'chuxo',
    component: Chuxo,
  },
  {
    path: '/chuxs',
    name: 'chuxs',
    component: Chuxs,
  },
  {
    path: '/chuxol',
    name: 'chuxol',
    component: Chuxol,
  },
  {
    path: '/chuxt',
    name: 'chuxt',
    component: Chuxt,
  },
  {
    path: '/jvip',
    name: 'jvip',
    component: Jvip,
  },
  {
    path: '/shen',
    name: 'shen',
    component: Shen,
  },
]

const router = new VueRouter({
  mode: 'hash',

  routes
})
router.beforeEach((to, from, next) => {
  // document.documentElement.scrollTop = 0
  // document.body.scrollTop = 0
  // console.log(from.name)
  if (to.name == 'home') {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    next()

  }
  if (to.name == 'my' || to.name == 'car') {

    if (JSON.parse(localStorage.getItem('user')).id != 0) {
      next()
    } else {
      next({ path: 'login', query: { aim: to.name } })
    }
  }
  if (from.name == 'cashier') {


    // if (to.name == 'transfer') {
    // } else {
    //   Dialog.confirm({
    //     title: '',
    //     message: '未选择支付方式订单将不会生成',
    //     confirmButtonText: '知道了'
    //   }).then(() => {
    //     next()
    //   }).catch(ref => { })
    //   next(false)
    //   // return false

    // }
    if (to.name == 'order') {
      next({ path: 'orderList', })

    }

  }
  if (from.name == 'orderList') {
    if (to.name == 'order') {
      next({ path: '/', })

    }

  }
  if (from.name == 'my') {
    if (to.name == 'over') {
      next({ path: '/', })

    }
    // next({ path: 'my', })
  }
  if (from.name == 'ss') {
    if (to.name == 'dao') {
      next({ path: '/', })

    }
    // next({ path: 'my', })
  }
  if (from.name == 'over') {
    if (to.name == 'opvip') {
      next({ path: 'my', })

    } else {
      // next({ path: 'my', })

    }
    // next({ path: 'my', })
  }

  // if (to.name == 'tao') {
  //   if (this.$store.state.scroll == 1) {
  //     window.scrollTo(1, 1000)
  //     next()

  //   } else {
  //     next()

  //   }

  // }
  // next({ path: 'my', })


  // if (from.name == 'home') {
  //   if (to.name == 'start') {
  //     // next({ path: '/', })
  //     // router.stop()
  //     if (sessionStorage.getItem("ks") == 1) {
  //       router.back()

  //     }
  //     stop()
  //     console.log(1)
  //   }
  // }
  // if (from.name == 'home') {
  //   if (to.name == 'city') {
  //     // next({ path: '/', })
  //     // router.stop()
  //     if (sessionStorage.getItem("ks") == 1) {
  //       router.back()
  //     }
  //     // stop()
  //     // console.log(1)
  //   }
  // }
  next()
})
export default router
